import $ from 'jquery'
import Page from "./components/CalendarPage"

export default function init() {
    new Page().init($('.workSchedulePage'))
}


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/index.js